// Device types based on Android DevicesFragmentNew.kt

export interface PumpManuallyItem {
  category: string;
  IsOn: boolean;
  lpmValue: number;
  slotNum: number;
  progress: number;
  alert: string;
  auxTrump: boolean;
  motorStatus?: number;
  isSpaOn?: boolean;
  isHeaterCoolDown?: boolean;
  heaterCoolDownTimer?: number;
  speedPriority?: number;
  scheduleInfo?: any;
  pump_type?: string;
  pump_brand?: string;
  pump_model?: string;
  timerDurationSec?: number;
  timerRemainSec?: number;
}

export interface Schedule {
  ID: number;
  DeviceID: string;
  Index: number;
  Name: string;
  IsScheduleOn: boolean;
  StartTime: number;
  EndTime: number;
  WeekDay: number;
}

export enum AuxTypeCode {
  EMPTY = 0,

  // pool
  AUX = 1,
  POOL_HEATER = 2,
  POOL_PRESSURE_CLEANER = 3,
  POOL_IN_FLOOR_CLEANING = 4,

  // dosing system
  SALT_CHLORINATOR = 5,
  PH_DOSER = 6,
  MINERAL_CHLORINATOR = 7,
  LIQUID_CHLORINE = 8,
  NAKED_IONISER = 9,
  OZONE = 10,
  UV = 11,

  // lights
  ASTRAL_POOL_LIGHT = 12,
  AQUAQUIP_LIGHT = 13,
  POOLRITE_LIGHT = 14,
  SPA_ELECTRICS_LIGHT = 15,
  ZODIAC = 16,

  // solar type code
  SOLAR_DEDICATED = 17,
  SOLAR_FILTER_PUMP = 18,

  // spa type code
  SPA_HEATER = 19,
  SPA_ACTUATOR_RETURN = 20,
  SPA_ACTUATOR_SUCTION = 21,
  SPA_JETS_1 = 22,
  SPA_JETS_2 = 23,
  SPA_BLOWER_1 = 24,
  SPA_BLOWER_2 = 25,
  SPA_ASTRAL_POOL_LIGHT = 26,
  SPA_AQUAQUIP_LIGHT = 27,
  SPA_POOLRITE_LIGHT = 28,
  SPA_SPA_ELECTRICS_LIGHT = 29,
  SPA_ZODIAC = 30,

  // pump
  SPALSHME_PUMP = 31,

  // combine heater for pool + spa
  COMBINE_POOL_SPA_HEATER = 32,

  SPA_ACTUATOR_EXTRA_1 = 33,
  SPA_ACTUATOR_EXTRA_2 = 34,

  PAL_LIGHTING = 35,
  SPA_PAL_LIGHTING = 36,
  RS485 = 999,

}

export function getAuxTypeDesc(value: number): string {
  switch (value) {
    case AuxTypeCode.EMPTY:
      return "";
    case AuxTypeCode.AUX:
      return "Auxiliary";
    case AuxTypeCode.POOL_HEATER:
      return "Pool Heater";
    case AuxTypeCode.POOL_PRESSURE_CLEANER:
      return "Pool Pressure Cleaner";
    case AuxTypeCode.POOL_IN_FLOOR_CLEANING:
      return "Pool In Floor Cleaner";
    case AuxTypeCode.SALT_CHLORINATOR:
      return "Salt Chlorinator";
    case AuxTypeCode.PH_DOSER:
      return "pH Doser";
    case AuxTypeCode.MINERAL_CHLORINATOR:
      return "Mineral Chlorinator";
    case AuxTypeCode.LIQUID_CHLORINE:
      return "Liquid Chlorine";
    case AuxTypeCode.NAKED_IONISER:
      return "Naked Ioniser";
    case AuxTypeCode.OZONE:
      return "Ozone";
    case AuxTypeCode.UV:
      return "UV";
    case AuxTypeCode.ASTRAL_POOL_LIGHT:
    case AuxTypeCode.AQUAQUIP_LIGHT:
    case AuxTypeCode.POOLRITE_LIGHT:
    case AuxTypeCode.SPA_ELECTRICS_LIGHT:
    case AuxTypeCode.ZODIAC:
      return "Pool Light";
    case AuxTypeCode.SOLAR_DEDICATED:
      return "Solar Dedicated Pump";
    case AuxTypeCode.SOLAR_FILTER_PUMP:
      return "Solar Filter Pump";
    case AuxTypeCode.SPA_HEATER:
      return "SPA Heater";
    case AuxTypeCode.SPA_ACTUATOR_RETURN:
      return "SPA Actuator Return";
    case AuxTypeCode.SPA_ACTUATOR_SUCTION:
      return "SPA Actuator Suction";
    case AuxTypeCode.SPA_JETS_1:
    case AuxTypeCode.SPA_JETS_2:
      return "SPA Jet";
    case AuxTypeCode.SPA_BLOWER_1:
    case AuxTypeCode.SPA_BLOWER_2:
      return "SPA Blower";
    case AuxTypeCode.SPA_ASTRAL_POOL_LIGHT:
    case AuxTypeCode.SPA_AQUAQUIP_LIGHT:
    case AuxTypeCode.SPA_POOLRITE_LIGHT:
    case AuxTypeCode.SPA_SPA_ELECTRICS_LIGHT:
    case AuxTypeCode.SPA_ZODIAC:
      return "SPA Pool Light";
    case AuxTypeCode.SPALSHME_PUMP:
      return "Main Pump";
    case AuxTypeCode.COMBINE_POOL_SPA_HEATER:
      return "Combine Pool SPA Heater";
    case AuxTypeCode.SPA_ACTUATOR_EXTRA_1:
      return "Spa Actuator Extra 1";
    case AuxTypeCode.SPA_ACTUATOR_EXTRA_2:
      return "Spa Actuator Extra 2";
    case AuxTypeCode.PAL_LIGHTING:
      return "PAL Lighting";
    case AuxTypeCode.SPA_PAL_LIGHTING:
      return "SPA PAL Lighting";
    case AuxTypeCode.RS485:
      return "RS485";
    default:
      return "";
  }
}

export enum LightTypeMode {
  LIGHT_UNKNOWN = 0,
  AQUAQUIP_INSTA_TOUCH = 1,
  SPA_ELECTRICS_MULTI_PLUS = 2,
  SPA_ELECTRICS_MULTI_COLOUR = 3,
  AQUAQUIP_MULTI_COLOUR = 4,
  PAL_COLOUR_TOUCH = 5,
}

export enum LightColourType {
  LIGHT_COLOUR_IDLE = 0,
  LIGHT_COLOUR_RED = 1,
  LIGHT_COLOUR_GREEN = 2,
  LIGHT_COLOUR_BLUE = 3,
  LIGHT_COLOUR_WHITE = 4,
  LIGHT_COLOUR_MAGENTA = 5,
  LIGHT_COLOUR_YELLOW = 6,
  LIGHT_COLOUR_CYAN = 7,
  LIGHT_COLOUR_PARTY = 8,
  LIGHT_COLOUR_ROMANCE = 9,
  LIGHT_COLOUR_CARIBBEAN = 10,
  LIGHT_COLOUR_AMERICAN = 11,
  LIGHT_COLOUR_SUNSET = 12,
  LIGHT_COLOUR_ROYAL = 13,
  LIGHT_COLOUR_NEXT_COLOUR = 14,
  LIGHT_COLOUR_SOLID_COLOUR = 15,
  LIGHT_COLOUR_GOLD = 16,
}

// Device category helpers
export const isSpaActuator = (device: number): boolean => {
  return [
    AuxTypeCode.SPA_ACTUATOR_RETURN,
    AuxTypeCode.SPA_ACTUATOR_SUCTION,
    AuxTypeCode.SPA_ACTUATOR_EXTRA_1,
    AuxTypeCode.SPA_ACTUATOR_EXTRA_2,
  ].includes(device);
};

export const isSpaDevice = (device: number): boolean => {
  return [
    AuxTypeCode.SPA_JETS_1,
    AuxTypeCode.SPA_JETS_2,
    AuxTypeCode.SPA_BLOWER_1,
    AuxTypeCode.SPA_BLOWER_2,
  ].includes(device);
};

export const isPumpLinkedDevice = (device: number): boolean => {
  return [
    AuxTypeCode.OZONE,
    AuxTypeCode.UV,
    AuxTypeCode.NAKED_IONISER,
    AuxTypeCode.POOL_IN_FLOOR_CLEANING,
    AuxTypeCode.POOL_PRESSURE_CLEANER,
  ].includes(device);
};

export const isSpecialDevice = (device: number): boolean => {
  return [
    AuxTypeCode.SPALSHME_PUMP,
    AuxTypeCode.SALT_CHLORINATOR,
    AuxTypeCode.PH_DOSER,
    AuxTypeCode.MINERAL_CHLORINATOR,
    AuxTypeCode.LIQUID_CHLORINE,
    AuxTypeCode.SOLAR_DEDICATED,
    AuxTypeCode.SOLAR_FILTER_PUMP,
    AuxTypeCode.POOL_HEATER,
    AuxTypeCode.SPA_HEATER,
    AuxTypeCode.COMBINE_POOL_SPA_HEATER,
    AuxTypeCode.SPA_ACTUATOR_RETURN,
    AuxTypeCode.SPA_ACTUATOR_SUCTION,
    AuxTypeCode.SPA_JETS_1,
    AuxTypeCode.SPA_JETS_2,
    AuxTypeCode.SPA_BLOWER_1,
    AuxTypeCode.SPA_BLOWER_2,
    AuxTypeCode.OZONE,
    AuxTypeCode.UV,
    AuxTypeCode.NAKED_IONISER,
    AuxTypeCode.POOL_IN_FLOOR_CLEANING,
    AuxTypeCode.POOL_PRESSURE_CLEANER,
  ].includes(device);
};

export const isSpaActuatorForWirelessButton = (device: number): boolean => {
  return [
    AuxTypeCode.SPA_ACTUATOR_RETURN,
    AuxTypeCode.SPA_ACTUATOR_SUCTION,
    AuxTypeCode.SPA_ACTUATOR_EXTRA_1,
    AuxTypeCode.SPA_ACTUATOR_EXTRA_2,
  ].includes(device);
};

export const canBeTimerForWirelessButton = (device: number): boolean => {
  return [
    AuxTypeCode.SPALSHME_PUMP,
    AuxTypeCode.AUX,
    AuxTypeCode.POOL_PRESSURE_CLEANER,
    AuxTypeCode.POOL_IN_FLOOR_CLEANING,
    AuxTypeCode.ASTRAL_POOL_LIGHT,
    AuxTypeCode.AQUAQUIP_LIGHT,
    AuxTypeCode.POOLRITE_LIGHT,
    AuxTypeCode.SPA_ELECTRICS_LIGHT,
    AuxTypeCode.ZODIAC,
    AuxTypeCode.SPA_ACTUATOR_RETURN,
    AuxTypeCode.SPA_ACTUATOR_SUCTION,
    AuxTypeCode.SPA_JETS_1,
    AuxTypeCode.SPA_JETS_2,
    AuxTypeCode.SPA_BLOWER_1,
    AuxTypeCode.SPA_BLOWER_2,
    AuxTypeCode.SPA_ASTRAL_POOL_LIGHT,
    AuxTypeCode.SPA_AQUAQUIP_LIGHT,
    AuxTypeCode.SPA_POOLRITE_LIGHT,
    AuxTypeCode.SPA_SPA_ELECTRICS_LIGHT,
    AuxTypeCode.SPA_ZODIAC,
    AuxTypeCode.SPA_ACTUATOR_EXTRA_1,
    AuxTypeCode.SPA_ACTUATOR_EXTRA_2,
    AuxTypeCode.PAL_LIGHTING,
    AuxTypeCode.SPA_PAL_LIGHTING,
  ].includes(device);
};

export const canBeTimerForAssignEquipment = (device: number): boolean => {
  return canBeTimerForWirelessButton(device);
};

export interface LightConfig {
  Type: number;
  TypeMode?: number;
  ColorMode?: number;
}


// Use getAuxTypeDesc instead of this function
export const getAuxTypeCodeName = getAuxTypeDesc;
